import { render, staticRenderFns } from "./CopyJsonButton.vue?vue&type=template&id=fc8402dc"
import script from "./CopyJsonButton.vue?vue&type=script&lang=js"
export * from "./CopyJsonButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports